<template>
  <div>

    <div class="menu_bg">
    </div>
    <div class="product-container">
      <div v-if="productType === 10" class="content">
        <h1 class="hero-title">{{ $t('messages.pogpinSingle') }}</h1>
      </div>
      <div v-if="productType === 11" class="content">
        <h1 class="hero-title">{{ $t('messages.pogopinConnector') }}</h1>
      </div>
      <div v-if="productType === 12" class="content">
        <h1 class="hero-title">{{ $t('messages.pogopinWaterpoofConnector') }}</h1>
      </div>
      <div v-if="productType === 13" class="content">
        <h1 class="hero-title">{{ $t('messages.pogopinMagneticConnector') }}</h1>
      </div>
      <div class="filter-container">
        <div class="input-container">
          <span>{{ $t('messages.outerDiameter') }}</span>
          <el-input size="medium" type="number" :placeholder="$t('messages.outerDiameterPlaceholder')"
            prefix-icon="el-icon-search" v-model="filterOuterDiameter" clearable @clear="filterOuterDiameter = null">
          </el-input>
        </div>
        <div class="input-container">
          <span>{{ $t('messages.length') }}</span>
          <el-input size="medium" type="number" :placeholder="$t('messages.lengthPlaceholder')"
            prefix-icon="el-icon-search" v-model="filterLength" clearable @clear="filterLength = null">
          </el-input>
        </div>
        <el-button style="margin-left: 10px;" type="primary" size="medium" @click="filterProducts">{{
          $t('messages.search') }}</el-button>
      </div>
      <div class="product-list" v-if="showProductList">
        <div class="grid-container">
          <div v-for="(item, index) in showProductList" :key="index" class="grid-item">
            <el-card
              :body-style="{ padding: '0px', display: 'flex', 'flex-direction': 'column', 'align-items': 'center', 'min-width': '500px' }">
              <span class="title">{{ item.model }}</span>
              <el-image style="width: 50%; " :src="item.image_list[0].url"
                :preview-src-list="[item.image_list[0].url]"></el-image>

            </el-card>
          </div>
        </div>

      </div>
    </div>


  </div>
</template>

<script>

export default {
  name: "Single",
  props: {
    // product: {
    //   type: Object,
    //   required: true
    // }
  },
  data () {
    return {
      allProductList: null,
      showProductList: null,
      productType: 10,
      filterOuterDiameter: null,
      filterLength: null,
    }
  },
  created () {
    this.productType = this.$route.query.type
    this.refreshPage()
  },

  async mounted () {

  },

  computed: {

  },
  watch: {
    '$route.query.type': function (newType) {
      console.log("newType: ", newType)
      this.productType = parseInt(newType)
      this.refreshPage()
    }
  },
  methods: {
    async filterProducts () {
      console.log("outerDiameter: ", this.filterOuterDiameter, " length: ", this.filterLength)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        let tmp = []
        if (this.allProductList == null || this.allProductList.length == 0) {
          return
        }
        this.allProductList.forEach(item => {
          if ((this.filterOuterDiameter == null && item.length == this.filterLength) || (this.filterLength == null && item.outer_diameter == this.filterOuterDiameter) || (item.outer_diameter == this.filterOuterDiameter && item.length == this.filterLength)) {
            tmp.push(item)
          }
          this.showProductList = tmp
        })
      } catch (error) {
        console.log("filterProducts error: ", error)
      } finally {
        loading.close()
      }
    },

    async refreshPage () {
      console.log("this.$route.query.type: ", this.$route.query.type)
      this.allProductList = null
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let isFinished = false
      let isDelayFinished = false
      setTimeout(() => {
        isDelayFinished = true
        if (!isFinished) {
          return;
        } else {
          this.showProductList = this.allProductList
          loading.close()
        }
      }, 1500);
      try {
        let res = await this.GetUrlsByHttp(this.GlobalData.productsUrl, this.$route.query.type)
        // console.log("resssss: ", res)
        let tmp = res.concat(res).concat(res).concat(res).concat(res).concat(res)
        this.allProductList = res
        // console.log("allProductList: ", this.allProductList[0].image_list)
      } catch (error) {
        console.log("error: ", error)
      } finally {
        isFinished = true
        if (isDelayFinished) {
          loading.close()
        }
      }
    }

  }
}
</script>

<style scoped>
.menu_bg {
  height: 100px;
  width: 100%;
  position: relative;
  background-size: cover;
  background-color: #00579C;
}

.hero.simple:after {
  z-index: 1;
  content: "";
  background: rgba(0, 0, 0, 0) linear-gradient(180deg, #000000 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.5;
}

@media (max-width: 1539px) {
  .hero.simple .content {
    padding: 24px 0 18px 48px;
  }
}

.content {
  /* position: absolute; */
  /* bottom: 0; */
  width: 100%;
  left: 0;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg,
      var(--unnamed-color-008682) 0%,
      rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg, #0077b4 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  padding: 24px 0 18px 73px;
}

.content .hero-title {
  margin: 0;
  padding: 0;
  color: #fff;
  font-size: 46px;
}

.product-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
}

.filter-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-left: 20px;
  margin-top: 15px;
}

.input-container {
  display: flex;
  align-items: center;
  flex-grow: 1;
  /* 让子元素自动扩展 */
  max-width: 300px;
  /* 确保最小宽度 */
  margin: 0;
  /* 移除外边距，使用 gap 来控制间距 */
  margin-left: 20px;
}

.input-container span {
  margin-right: 8px;
  /* 调整间距 */
  line-height: normal;
  /* 确保文本基线对齐 */
  min-width: 50px;
}

.grid-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  /* 间隙 */
}

.grid-item {
  flex-basis: calc(50% - 50px);
  /* 计算每个项目的宽度，减去间隙的一半 */
  /* background-color: #ddd; */
  padding: 10px;
  text-align: center;
}

.title {
  font-size: 18px;
  margin-top: 10px;
  color: #00579c;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Products/PogopinProbes/PogopinProbes.vue